import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19356 20828"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970278507248">
        <path
          d="M14278 18363c-147 0-331-38-479-148l-4820-2870c-147-74-331-74-478 0l-4821 2870c-626 368-1398-73-1398-772 0-332 183-626 441-773l5998-3607 5998 3607c258 147 442 478 442 773 73 515-368 920-883 920zm956-2503-6219-3717c-147-73-330-73-478 0l-6219 3717c-551 332-883 920-883 1583 0 1030 810 1840 1840 1840 331-1 662-74 957-258l4563-2760 4563 2760c736 441 1656 294 2208-258 883-846 699-2281-332-2907z"
          className="fil0"
        />
        <path
          d="M13836 12732 9015 9862c-147-74-330-74-478 0l-4820 2870c-626 368-1399-73-1399-773 0-331 184-625 442-772l5998-3607 5998 3607c258 147 442 478 442 772 36 663-773 1141-1362 773zm1398-2391L9015 6624c-147-74-330-74-478 0l-6219 3717c-551 331-883 920-883 1582 0 1030 810 1839 1840 1839 331 0 662-73 957-257l4563-2760 4563 2760c1214 736 2796-147 2796-1582 0-626-367-1251-920-1582z"
          className="fil0"
        />
        <path
          d="M14940 7065c-294 295-736 368-1104 111L9015 4305c-147-73-330-73-478 0L3717 7176c-626 367-1399-74-1399-773 0-331 184-625 442-773l5998-3606 5998 3606c515 295 626 1030 184 1435zm294-2245L9015 1104c-147-74-330-74-478 0L2318 4820c-551 332-883 921-883 1583 0 1030 810 1840 1840 1840 331 0 662-74 957-258l4563-2759 4563 2759c294 184 625 258 957 258 0 0 699 37 1288-516 846-846 662-2281-369-2907zM17737 16670c-111 0-221-111-221-221s110-221 221-221c110 0 221 111 221 221 37 110-74 221-221 221zm0-1399c-625 0-1141 515-1141 1141s516 1141 1141 1141 1141-515 1141-1141c36-626-516-1141-1141-1141zM16596 2871c0-516 405-921 920-921s920 405 920 921c0 515-405 919-920 919s-920-404-920-919zm2760 0c0-1031-810-1841-1840-1841s-1840 810-1840 1841c0 1030 810 1839 1840 1839s1840-846 1840-1839zM10525 0c264 0 478 214 478 478 0 265-214 479-478 479-265 0-479-214-479-479 0-264 214-478 479-478zM17516 7912c264 0 478 214 478 478 1 264-214 478-478 478s-478-214-478-478 214-478 478-478zM17074 13432c265 0 479 214 479 478s-214 478-479 478c-263 0-478-214-478-478s215-478 478-478zM4158 1030c244 0 442 198 442 442s-198 442-442 442-441-198-441-442 197-442 441-442zM478 14352c265 0 479 214 479 478s-214 478-479 478c-264 0-478-214-478-478s214-478 478-478zM6918 19871c264 0 478 214 478 478 0 265-214 479-478 479s-478-214-478-479c0-264 214-478 478-478z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
